/**
 * Format currency in USD
 * @param {number} amount - Amount to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '$0.00';
  
  const isNegative = amount < 0;
  const absAmount = Math.abs(amount);
  
  return `${isNegative ? '-' : ''}₹${absAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Alias for backward compatibility
export const formatIndianCurrency = formatCurrency;

/**
 * Format date in Indian format (DD/MM/YYYY)
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatIndianDate = (date) => {
  if (!date) return '-';
  
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  
  return `${day}/${month}/${year}`;
};

/**
 * Format date and time in Indian format
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date and time string
 */
export const formatIndianDateTime = (date) => {
  if (!date) return '-';
  
  const d = new Date(date);
  const dateStr = formatIndianDate(d);
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  
  return `${dateStr} ${hours}:${minutes}`;
};

/**
 * Format percentage
 * @param {number} value - Value to format
 * @returns {string} Formatted percentage string
 */
export const formatPercentage = (value) => {
  if (value === null || value === undefined) return '0%';
  return `${value.toFixed(2)}%`;
};

/**
 * Mask Aadhaar number
 * @param {string} aadhaar - Aadhaar number
 * @returns {string} Masked Aadhaar
 */
export const maskAadhaar = (aadhaar) => {
  if (!aadhaar) return '';
  return `XXXX-XXXX-${aadhaar.slice(-4)}`;
};

/**
 * Mask PAN number
 * @param {string} pan - PAN number
 * @returns {string} Masked PAN
 */
export const maskPAN = (pan) => {
  if (!pan) return '';
  return `${pan.slice(0, 3)}XXXX${pan.slice(-1)}`;
};